var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "form-item__field form-item__field--full",
      class: _vm.classes,
    },
    [
      _c(
        "div",
        { staticClass: "input-group input-group-booking-detail input-height" },
        [
          _c("label", { staticClass: "input-label input-group-addon" }, [
            _vm._v(_vm._s(_vm.label)),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-control input-height input-container" },
            [
              !_vm.editing
                ? _c(
                    "div",
                    _vm._l(_vm.localField, function (item) {
                      return _c("p", { key: item }, [
                        _vm._v("\n          " + _vm._s(item)),
                        _vm.otherSelected && item === _vm.otherValue
                          ? _c("span", [
                              _vm._v(" - " + _vm._s(_vm.localOtherField)),
                            ])
                          : _vm._e(),
                      ])
                    }),
                    0
                  )
                : _vm._l(_vm.options, function (option, index) {
                    return _c(
                      "div",
                      {
                        key: option.id,
                        staticClass: "checkbox checkbox-primary",
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.localField,
                              expression: "localField",
                            },
                          ],
                          attrs: { type: "checkbox", id: `checkbox-${index}` },
                          domProps: {
                            value: option.id,
                            checked: Array.isArray(_vm.localField)
                              ? _vm._i(_vm.localField, option.id) > -1
                              : _vm.localField,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.localField,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = option.id,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.localField = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.localField = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.localField = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: `checkbox-${index}` } }, [
                          _vm._v(_vm._s(option.text)),
                        ]),
                        _vm._v(" "),
                        _vm.otherSelected && option.id === _vm.otherValue
                          ? _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.localOtherField,
                                  expression: "localOtherField",
                                },
                              ],
                              staticClass: "form-control",
                              attrs: { name: "other_text", type: "text" },
                              domProps: { value: _vm.localOtherField },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.localOtherField = $event.target.value
                                },
                              },
                            })
                          : _vm._e(),
                      ]
                    )
                  }),
            ],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }